/* import __COLOCATED_TEMPLATE__ from './minutes.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();